import { render, staticRenderFns } from "./ConfigPanel.vue?vue&type=template&id=61c717c9&scoped=true"
import script from "./ConfigPanel.vue?vue&type=script&lang=ts"
export * from "./ConfigPanel.vue?vue&type=script&lang=ts"
import style0 from "./ConfigPanel.vue?vue&type=style&index=0&id=61c717c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c717c9",
  null
  
)

export default component.exports